var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6249 1.49979C11.6253 1.58205 11.6096 1.66359 11.5785 1.73974C11.5474 1.81588 11.5015 1.88514 11.4436 1.94354L6.44362 6.94354C6.38552 7.00212 6.31639 7.04862 6.24023 7.08035C6.16407 7.11208 6.08238 7.12842 5.99987 7.12842C5.91736 7.12842 5.83567 7.11208 5.75951 7.08035C5.68335 7.04862 5.61422 7.00212 5.55612 6.94354L0.556122 1.94354C0.438432 1.82585 0.372314 1.66623 0.372314 1.49979C0.372314 1.33336 0.438432 1.17373 0.556122 1.05604C0.673811 0.938355 0.833433 0.872237 0.999872 0.872237C1.16631 0.872237 1.32593 0.938355 1.44362 1.05604L5.99987 5.61854L10.5561 1.05604C10.6142 0.997464 10.6833 0.950966 10.7595 0.919236C10.8357 0.887506 10.9174 0.87117 10.9999 0.87117C11.0824 0.87117 11.1641 0.887506 11.2402 0.919236C11.3164 0.950966 11.3855 0.997464 11.4436 1.05604C11.5015 1.11444 11.5474 1.1837 11.5785 1.25985C11.6096 1.336 11.6253 1.41754 11.6249 1.49979Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.ea54ec409f1fec086cee589b1b5295df.svg";
export { ForwardRef as ReactComponent };